import { useEffect, useState } from 'react'
import { modulesService, type ModuleCode } from '@/services/modulesService'

/**
 * Módulos contratados por la organización del usuario. `null` mientras carga o si la
 * consulta falla: en ese caso no se oculta nada (el backend igual bloquea lo no
 * contratado; esconder el menú es solo comodidad).
 */
export function useModules(enabled: boolean): Set<ModuleCode> | null {
    const [modules, setModules] = useState<Set<ModuleCode> | null>(null)

    useEffect(() => {
        if (!enabled) return
        let active = true
        modulesService.myModules()
            .then((m) => { if (active) setModules(new Set(m)) })
            .catch(() => { if (active) setModules(null) })
        return () => { active = false }
    }, [enabled])

    return modules
}
